import { Tabs } from '@lmc/ui-kit'
import type { TabsProps } from 'antd'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { DrawerAbout } from './DrawerAbout'
import {
  DrawerAllocatedTeam,
  type InstanceWarningMaps
} from './DrawerAllocatedTeam'

type DrawerBodyProps = {
  revisionDetail: any
  onTabChange?: (key: string) => void
  defaultTab?: number
  publishedRota?: boolean
  instanceWarningMaps?: InstanceWarningMaps | null
}

export const DrawerBody: FC<DrawerBodyProps> = ({
  revisionDetail,
  onTabChange,
  defaultTab,
  publishedRota,
  instanceWarningMaps
}) => {
  const { t } = useTranslation()

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: t('ABOUT'),
      children: (
        <DrawerAbout
          revisionDetail={revisionDetail}
          publishedRota={publishedRota}
        />
      )
    },
    {
      key: '2',
      label: t('TEAM_DETAILS'),
      children: (
        <DrawerAllocatedTeam
          revisionDetail={revisionDetail}
          publishedRota={publishedRota}
          instanceWarningMaps={instanceWarningMaps}
        />
      )
    }
  ]

  return (
    <div>
      <Tabs
        defaultActiveKey={defaultTab?.toString()}
        items={items}
        onChange={onTabChange}
        size="large"
      />
    </div>
  )
}
